import {Component, EventEmitter, HostListener, Output, ViewEncapsulation} from '@angular/core';
import {config} from '../../../../config/config';
import {ImageService} from '../../../services/image.service';
import {bindFunctionsToThis} from '../../extensions';
import * as jwt_decode from "jwt-decode";
import {GlobalEventEmitter} from "../../services/global.event.emitter";

declare const gapi: any;

@Component({
    selector: 'ig-google-login-btn',
    templateUrl: './google.login.button.component.html',
    styleUrls: ['./google.login.button.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class GoogleLoginButtonComponent {
    public auth2: any;
    public profilePicture: string;
    public static isUserLoggedWithGoogle: boolean;
    public static googleUserId: string;
    public static profilePicture: string;
    @Output() onLoginStatusChanged: EventEmitter<any> = new EventEmitter();

    constructor(public imageService: ImageService) {
        bindFunctionsToThis(this);

        try {
            setTimeout(() => {
                this.initializeGoogle();
            }, 2000);
        } catch (e) {
            console.warn(e);
        }
    }

    @HostListener('window:onGoogleLibraryLoad', ['$event'])
    public initializeGoogle() {
        console.log('initializing google');
        google['accounts'].id.initialize({
            client_id: '665289826545-463bhl103plveo5l05b94vjnenmr3f7e',
            callback: (data) => {
                console.log('google initialized', data);
                if (data['credential']) {
                    const credential = jwt_decode(data['credential']);
                    console.log('credential', credential);

                    this.profilePicture = credential['picture'];
                    GoogleLoginButtonComponent.isUserLoggedWithGoogle = true;
                    GoogleLoginButtonComponent.googleUserId = credential['email'];
                    GoogleLoginButtonComponent.profilePicture = this.profilePicture;
                    console.log(`googleId: ${GoogleLoginButtonComponent.googleUserId}`);
                    this.onLoginStatusChanged.emit(true);
                    // notify share.trip.modal.component to close the modal
                    GlobalEventEmitter.emit('onGoogleLoginStatusChanged');
                }
            }
        });

        google['accounts'].id.renderButton(
            document.getElementById("google-signin-btn"),
            {theme: "outline", size: "large"}
        );
    }

    public login() {
    }

    public logout() {
        if (this.isUserLoggedWithGoogle) {
            google['accounts'].id.disableAutoSelect();
            GoogleLoginButtonComponent.isUserLoggedWithGoogle = false;
            this.onLoginStatusChanged.emit(false);
        }
    }

    public get isUserLoggedWithGoogle() {
        return GoogleLoginButtonComponent.isUserLoggedWithGoogle;
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/google.login.button/google.login.button.component.ts